<template>
    <div class="w-full h-full relative">
        <video
            style="width: 100%"
            controls
            v-show="state.isPlaying"
            ref="videoRef"
        >
            <source :src="props.url" type="video/mp4" />
        </video>
        <div
            class="relative"
            :style="`height: ${props.isScreenAuto ? 'auto' : '180px'};`"
            v-if="!state.isPlaying"
        >
            <div
                class="
                    absolute
                    top-1
                    left-2
                    px-1
                    bg-[#00000075]
                    text-[12px] text-white
                "
            >
                {{ state.duration }}
            </div>
            <img
                :src="props.thumbnail"
                :style="`height: ${props.isScreenAuto ? 'auto' : '180px'};`"
            />
        </div>
        <div
            class="
                absolute
                top-0
                left-0
                w-full
                h-full
                flex
                items-center
                justify-center
                text-white
                bg-black/30
                cursor-pointer
            "
            v-show="!state.isPlaying"
            v-on:click.stop="play"
        >
            <ion-icon name="play" size="lg" style="font-size: 4em"></ion-icon>
        </div>
    </div>
</template>

<script setup>
import ModalCustom from "./ModalCustom";
import TagForm from "./TagForm";
import { createPopper } from "@popperjs/core";
import Modal from "./Modal";
import AppInput from "./AppInput";
import AppButton from "./AppButton";
import { ref, onMounted, watch, nextTick, reactive, defineEmits } from "vue";
import draggable from "vuedraggable";
import { formatTime } from "../utils/timer";

const props = defineProps({
    thumbnail: {
        type: String,
        required: false,
    },
    url: {
        type: String,
        required: true,
    },
    isScreenAuto: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const state = reactive({
    isPlaying: false,
    duration: "00:00",
});

const videoRef = ref(null);

function play() {
    state.isPlaying = true;
    if (videoRef.value) {
        videoRef.value.play();
    }
}

onMounted(() => {
    var i = setInterval(function () {
        if (videoRef.value) {
            state.duration = formatTime(videoRef.value.duration);

            clearInterval(i);
        }
    }, 200);
});
</script>

<style scoped></style>
